// Wishlist Preferences v2 — Brand multi-select (Feb 2026).
// Thin wrapper around CatalogMultiSelect that pre-wires:
//   • endpoint:        GET /catalog/brands
//   • label rendering: proper-noun brand names — NOT translated
//   • optional sport filter toggle, default OFF (per Roberto's directive).
//
// The toggle uses the user's `preferred_sport` from L2 segmentation if
// available; otherwise it falls back to "tennis" as a sensible default.
// The default is OFF: we don't want to hide brands from the user at first
// sight.

import React, { useState } from "react";
import { Filter } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import CatalogMultiSelect from "./CatalogMultiSelect";

export const BrandMultiSelect = ({
  value,
  customValue,
  onChange,
  onCustomChange,
  t,
  userSport = "",
}) => {
  const [sportFilterOn, setSportFilterOn] = useState(false);
  const filterValue = sportFilterOn && userSport ? userSport : "";

  return (
    <div className="space-y-2">
      <CatalogMultiSelect
        endpoint="/catalog/brands"
        value={value || []}
        customValue={customValue || []}
        onChange={onChange}
        onCustomChange={onCustomChange}
        renderLabel={(it) => it.label}
        filterParamKey="sport"
        filterValue={filterValue}
        t={t}
        testIdPrefix="wlp-brand"
        label={t("settings.wishlistV2.brands.label")}
        placeholder={t("settings.wishlistV2.brands.placeholder")}
        searchPlaceholder={t("settings.wishlistV2.brands.searchPlaceholder")}
        searchEmpty={t("settings.wishlistV2.brands.searchEmpty")}
        otherLabel={t("settings.wishlistV2.brands.otherLabel")}
        otherPlaceholder={t("settings.wishlistV2.brands.otherPlaceholder")}
      />
      {userSport && (
        <label
          className="inline-flex items-center gap-2 text-xs text-slate-500 cursor-pointer"
          data-testid="wlp-brand-sport-filter"
        >
          <Filter className="h-3 w-3" />
          <Switch
            checked={sportFilterOn}
            onCheckedChange={setSportFilterOn}
            aria-label="Filter brands by my sport"
          />
          <span>
            {t("settings.wishlistV2.brands.sportFilter")} (<code>{userSport}</code>)
          </span>
        </label>
      )}
    </div>
  );
};

export default BrandMultiSelect;
